//------------------------------------------------------ externos
import { useEffect, useMemo, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../funcionales/FormContent";
import MarcoModal from "../funcionales/MarcoModal";
import FormHeader from "../funcionales/FormHeader";
import TextButton from "../buttons/TextButton";
import Loading from "../../routes/Loading";
import CodigosDeBarras from "../funcionales/CodigosDeBarras";
//------------------------------------------------------ funciones
import { cargarSelects } from "../../functions/dataFunctions";
import { submitStock } from "./data/Submits";
import { elementos } from "./data/FormContent";
import { obligatoriosAlEditar, unidadParaElFormulario } from "../../shared/stockEdicion";
import { codigosDelArticulo } from "../../services/stockCodigos";
//import { refreshCache } from "../../services/cache";
//------------------------------------------------------ estilos
import "./css/Forms.css";

const FormStock = ({ elemento = null, onGuardar, onClose }) => {
  const modoEdicion = !!elemento;
  const titulo = modoEdicion ? "Editar" : "Agregar";
  const subtitulo = "Articulo / Repuesto";
  /* Al editar, lo que la fila ya tenía vacío no traba el guardado (ver
     `obligatoriosAlEditar`): los artículos del escaneo nacen sin marca, y
     corregirles el nombre no puede exigir inventarles una. */
  const campos = useMemo(
    () => obligatoriosAlEditar(elementos["stock"], elemento),
    [elemento],
  );

  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({}); //para los selects, recibe un array tipo {tractores: ..., furgones: ...}
  const [formData, setFormData] = useState({
    // información específica
    id: elemento?.id || "",
    tipo: elemento?.tipo || "",
    descripcion: elemento?.descripcion || "",
    unidad: unidadParaElFormulario(elemento?.unidad),
    deposito: elemento?.deposito || "",
    marca: elemento?.marca || "",
    proveedor: elemento?.proveedor || "",
    codigoProveedor: elemento?.codigoProveedor || "",
    // detalles y comentarios
    detalle: elemento?.detalle || "",
  });

  /* Los códigos de barras, sólo al editar: un artículo que todavía no existe
     no tiene fila a la que colgarlos (`stock_codigos.articulo` apunta a
     `stock.id`). `originales` es lo que había al abrir, para escribir sólo
     la diferencia al guardar. */
  const [codigos, setCodigos] = useState({
    originales: [], actuales: [], cargando: modoEdicion, error: "",
  });
  useEffect(() => {
    if (!modoEdicion || !elemento?.id) return;
    let vivo = true;
    codigosDelArticulo(elemento.id).then(({ codigos: lista, error }) => {
      if (!vivo) return;
      setCodigos({ originales: lista, actuales: lista, cargando: false, error });
    });
    return () => {
      vivo = false;
    };
  }, [modoEdicion, elemento?.id]);

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects(); // trae TODOS los listados, ver si se puede mejorar desp
      setListas(data);
    };

    cargarDatos();
    setLoading(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await submitStock(
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
      modoEdicion,
      elemento?.id,
      /* Sin haber podido leer los códigos no se tocan: la diferencia contra
         una lista que no se leyó borraría o duplicaría lo que hay. */
      modoEdicion && !codigos.cargando && !codigos.error
        ? { codigos: { originales: codigos.originales, actuales: codigos.actuales } }
        : {},
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="form-content">
          <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />

          <FormContent
            elemento={elemento}
            campos={campos}
            opciones={listas}
            data={formData}
            listado={listas["stock"]}
            setData={setFormData}
          />

          {modoEdicion && (
            <>
              {/* EL CÓDIGO NO CAMBIA. Las dos letras del tipo y los dos números
                  del proveedor arman el código al dar de alta, pero después
                  ese código ya está en movimientos, depósitos, etiquetas y en
                  lo que contesta el escaneo. Cambiar el tipo corrige el tipo,
                  no renumera el artículo — y si no se dice, alguien va a
                  esperar que lo haga. */}
              <p className="codigos-barras-nota-codigo">
                El código <strong>{elemento.id}</strong> queda como está aunque
                cambies el tipo o el proveedor. La cantidad no se edita acá:
                sale de los movimientos.
              </p>
              <CodigosDeBarras
                codigos={codigos.actuales}
                cargando={codigos.cargando}
                error={codigos.error}
                onChange={(actuales) => setCodigos((c) => ({ ...c, actuales }))}
              />
            </>
          )}

          <div className="form-buttons">
            <TextButton
              text={"Guardar"}
              type={"button"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormStock;
